module.exports = __webpack_public_path__ + "img/bj_peitu.fc75d410.png";